"use client";

import { CalendarClock, Clock, MapPin, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pillars = [{
  title: "Your time is the schedule.",
  description: "We track your flight in real time and adjust automatically. No waiting, no calls, no excuses.",
  icon: Clock
}, {
  title: "Professionals, not just drivers.",
  description: "Every chauffeur is background‑checked, licensed, and trained for executive‑level discretion.",
  icon: ShieldCheck
}, {
  title: "What happens in the vehicle stays there.",
  description: "Conversations, destinations, passengers — handled with absolute confidentiality, always.",
  icon: CalendarClock
}, {
  title: "Every Bay Area airport. One standard.",
  description: "SFO, OAK, and SJC — meet‑and‑greet service at every terminal, 24 hours a day.",
  icon: MapPin
}];
export default function TheGoldStandard() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="120135" id="our-commitment-to-excellence" className="dark bg-background text-foreground py-12 border-y border-primary/20 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-6">
          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <div key={i} data-index={i} className={`flex flex-col items-center text-center space-y-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                <Icon className="w-9 h-9 text-primary stroke-[1.25]" />
                <div className="space-y-1.5">
                  <h3 className="text-sm font-bold text-foreground tracking-widest uppercase font-mono">
                    {pillar.title}
                  </h3>
                  <p className="text-xs text-muted-foreground max-w-[240px] mx-auto leading-relaxed uppercase tracking-wider font-sans">
                    {pillar.description}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}